
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Signin from './components/Login/Signin';
import HomePage from './components/HomePage';
import Dashboard from './components/Dashboard/Dashboard';
import Navbar from './components/Navbar/Navbar';
import DailyUpdate from './components/DailyUpdate/DailyUpdate';
import NewHire from './components/NewHire/NewHire';
import DailyUpdateApproval from './components/DailyUpdateApproval/DailyUpdateApproval';
import NewHireDetails from './components/NewHire/NewHireDetails';
import TaskDetails from './components/Task/TaskDetails/TaskDetails';
import TaskAssign from './components/Task/TaskAssign/TaskAssign';
import TaskDashboard from './components/Task/TaskDashboard/TaskDashboard';
import WorklogReport from './components/Task/WorklogReport/WorklogReport';
import OnBoarding from './components/NewHire/OnBoarding';
import TimeSheet from './components/TimeSheet/TimeSheet';
import EmployeeDetails from './components/Employee/Employee';
import SupportEmployeeDetails from './components/Employee/SupportEmployee';
import TimesheetApproval from './components/TimeSheet/TimeSheetApproval';
import SocialPost from './components/SocialPost/SocialPost';
import LeaveApply from './components/Leave/LeaveApply';
import LeaveApproval from './components/Leave/LeaveApproval';
import LeaveReport from './components/Leave/LeaveReport';
import PayRoll from './components/PayRoll/PayRoll';
import ChangePassword from './components/ChangePwd/ChangePassword';
import ForgotPassword from './components/ForgetP/ForgotPassword';
import LeaveBalance from './components/Leave/LeaveBalance';
import TaskBoard from './components/Task/TaskBoard';
import ClientDetails from './components/Configuration/Client/ClientDetails';
import NoticeDetails from './components/Configuration/Notice/Notice';
import Alert from './components/Alert/Alert';
import ContractEmployeeList from './components/Employee/ContractEmployee';
import AllEmployees from './components/Employee/AllEmployees';
import Passout from './components/Leave/Passout';
import GemBid from './components/Gem/GemBid';
import GemPendingList from './components/Gem/GemPendingList';
import GemEnableFilter from './components/Gem/GemEnableFilter';
import GemCompletedList from './components/Gem/GemCompletedList';
import Customer from './components/Customer/Customer';
import Project from './components/Project/Project';
import Holiday from './components/Configuration/Holiday'; 
import Designation from './components/Configuration/Designation'; 
import EmailData from './components/Configuration/EmailData';
import AuditStampingList from './components/Configuration/AuditStamping';
import ProjectAccess from './components/Configuration/ProjectAccess';
import ReportIssue from './components/ReportIssue/ReportIssue'
import ReportDetails from './components/ReportIssue/ReportDetails'
import PendingIssues from './components/ReportIssue/PendingIssues'
import ClosedIssueList from './components/ReportIssue/ClosedIssueList'
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet"></link>


function App() {
  return (
    <div>

       
      <Routes>
        <Route path="/" element={<HomePage />}> </Route>
        <Route path="/signin" element={<Signin/>}> </Route>
        <Route path="/dashboard" element={<Dashboard />}> </Route>
        <Route path="/navbar" element={<Navbar />}> </Route>
        <Route path='/dailyUpdate' element={<DailyUpdate/>}></Route>
        <Route path='/newhire' element={<NewHire/>}></Route>
        <Route path='/newHireDetails' element={<NewHireDetails/>}></Route>
        <Route path='/dailyUpdateApproval' element={<DailyUpdateApproval/>}></Route>
        <Route path='/taskDetails' element={<TaskDetails/>}></Route>
        <Route path='/taskAssign' element={<TaskAssign/>}></Route>
        <Route path='/taskDashboard' element={<TaskDashboard/>}></Route>
        <Route path='/worklogReport' element={<WorklogReport/>}></Route>
        <Route path='/taskBoard' element={<TaskBoard/>}></Route>

        <Route path='/onboarding' element={<OnBoarding/>}></Route>
        <Route path='/timesheet' element={<TimeSheet/>}></Route>
        <Route path='/employee' element={<EmployeeDetails/>}></Route>
        <Route path='/contractEmployee' element={<ContractEmployeeList/>}></Route>
        <Route path='/allEmployees' element={<AllEmployees/>}></Route>
        <Route path='/timesheetApproval' element={<TimesheetApproval/>}></Route>
        <Route path='/social' element={<SocialPost/>}></Route>
        <Route path='/leaveApply' element={<LeaveApply/>}></Route>
        <Route path='/leaveApproval' element={<LeaveApproval/>}></Route>
        <Route path='/leaveReport' element={<LeaveReport/>}></Route>
        <Route path="/payroll" element={<PayRoll />}> </Route>
        <Route path="/changePassword" element={<ChangePassword />}> </Route>
        <Route path="/forgotPassword" element={<ForgotPassword />}> </Route>
        <Route path="/leaveBalance" element={<LeaveBalance />}> </Route>
        <Route path="/client" element={<ClientDetails />}> </Route>
        <Route path="/notice" element={<NoticeDetails />}> </Route>
        <Route path="/alert" element={<Alert />}> </Route>
        <Route path="/passout" element={<Passout />}> </Route>
        <Route path='/supportEmployee' element={<SupportEmployeeDetails />}></Route>
        <Route path='/gemBidList' element={<GemBid />}></Route>
        <Route path='/gemPendingList' element={<GemPendingList />}></Route>
        <Route path='/gemCompletedList' element={<GemCompletedList />}></Route>
        <Route path='/gemEnalbeFilterlist' element={<GemEnableFilter />}></Route>
        <Route path='/customer' element={<Customer />}></Route>
        <Route path='/project' element={<Project />}></Route>
        <Route path='/designation' element={<Designation />}></Route>
        <Route path='/holidays' element={<Holiday />}></Route>
        <Route path='/emailData' element={<EmailData />}></Route>
        <Route path='/audit-stamping' element={<AuditStampingList />}></Route>
        <Route path='/project-access' element={<ProjectAccess />}></Route>
        <Route path='/reportIssue' element={<ReportIssue />}></Route>
        <Route path='/reportDetails' element={<ReportDetails />}></Route>
        <Route path='/pendingIssues' element={<PendingIssues />}></Route>
        <Route path='/closedReports' element={<ClosedIssueList />}></Route>
      </Routes>
    </div>
  );
}

export default App;
